'use strict';

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

var tslib_es6 = require('./tslib.es6-fe93d37b.js');
var React = require('react');
var React__default = _interopDefault(React);
var styled = require('styled-components');
var styled__default = _interopDefault(styled);
var arrowAltLeft = require('./arrow-alt-left-932a33f8.js');
var arrowDownMaterial = require('./arrow-down-material-25c60327.js');

var StyledLink = styled__default.button(templateObject_1 || (templateObject_1 = tslib_es6.__makeTemplateObject(["\n  all: unset;\n  text-decoration: none;\n  color: ", ";\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n"], ["\n  all: unset;\n  text-decoration: none;\n  color: ", ";\n  display: flex;\n  align-items: center;\n  cursor: pointer;\n  font-weight: 500;\n  font-size: 16px;\n  line-height: 24px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var BackIcon = styled__default(arrowDownMaterial.ArrowDownMaterial)(templateObject_2 || (templateObject_2 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  transform: rotate(90deg);\n  margin-right: 4px;\n"], ["\n  color: ", ";\n  transform: rotate(90deg);\n  margin-right: 4px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.fontColor;
});
var BackIconAlt = styled__default(arrowAltLeft.ArrowAltLeft)(templateObject_3 || (templateObject_3 = tslib_es6.__makeTemplateObject(["\n  color: ", ";\n  margin-right: 4px;\n"], ["\n  color: ", ";\n  margin-right: 4px;\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.greys.adminGreyDark;
});
var StyledSpan = styled__default.span(templateObject_4 || (templateObject_4 = tslib_es6.__makeTemplateObject(["\n  font-size: ", ";\n  line-height: 16px;\n  font-weight: 500;\n  font-family: ", ";\n"], ["\n  font-size: ", ";\n  line-height: 16px;\n  font-weight: 500;\n  font-family: ", ";\n"])), function (_a) {
    var theme = _a.theme;
    return theme.fontSizes.sm;
}, function (_a) {
    var theme = _a.theme;
    return theme.fonts.join();
});
var templateObject_1, templateObject_2, templateObject_3, templateObject_4;

var BackLink = function (_a) {
    var className = _a.className, backLinkText = _a.backLinkText, _b = _a.backIconSize, backIconSize = _b === void 0 ? 'md' : _b, _c = _a.iconVariant, iconVariant = _c === void 0 ? 'primary' : _c, onPressBack = _a.onPressBack, _d = _a.WrapperComponent, WrapperComponent = _d === void 0 ? React.Fragment : _d;
    return (React__default.createElement(WrapperComponent, null,
        React__default.createElement(StyledLink, { className: className, "data-cy": "back-link", "data-testid": "back-link", onClick: onPressBack || undefined },
            iconVariant === 'primary'
                ? React__default.createElement(BackIcon, { size: backIconSize, dataTestId: "icon-primary" })
                : React__default.createElement(BackIconAlt, { size: backIconSize, dataTestId: "icon-secondary" }),
            React__default.createElement(StyledSpan, null, backLinkText))));
};

exports.BackLink = BackLink;
